import React from 'react';
import PropTypes from 'prop-types';

export const IconBonus = ({ className }) => (
  <svg className={className} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.3389 15.1699V23.3366C23.3389 23.981 22.8166 24.5033 22.1722 24.5033H5.83887C5.19454 24.5033 4.6722 23.981 4.6722 23.3366V15.1699H23.3389ZM16.9222 2.33661C19.1774 2.33661 21.0056 4.16478 21.0056 6.41995C21.0056 7.04668 20.8644 7.64044 20.612 8.17116L24.5056 8.16995C25.1499 8.16995 25.6722 8.69227 25.6722 9.33661V12.8366C25.6722 13.481 25.1499 14.0033 24.5056 14.0033H3.50553C2.86121 14.0033 2.33887 13.481 2.33887 12.8366V9.33661C2.33887 8.69227 2.86121 8.16995 3.50553 8.16995L7.39906 8.17116C7.14674 7.64044 7.00553 7.04668 7.00553 6.41995C7.00553 4.16478 8.83371 2.33661 11.0889 2.33661C12.2322 2.33661 13.2658 2.8065 14.007 3.56369C14.7453 2.8065 15.7789 2.33661 16.9222 2.33661ZM11.0889 4.66995C10.1224 4.66995 9.33887 5.45344 9.33887 6.41995C9.33887 7.32958 10.0329 8.07714 10.9203 8.16193L11.0889 8.16995H12.8389V6.41995C12.8389 5.5103 12.1448 4.76275 11.2574 4.67795L11.0889 4.66995ZM16.9222 4.66995L16.7536 4.67795C15.9217 4.75746 15.2597 5.41945 15.1802 6.25141L15.1722 6.41995V8.16995H16.9222L17.0907 8.16193C17.9782 8.07714 18.6722 7.32958 18.6722 6.41995C18.6722 5.5103 17.9782 4.76275 17.0907 4.67795L16.9222 4.66995Z"
      fill="white"
    />
  </svg>
);

IconBonus.propTypes = {
  className: PropTypes.string,
};

IconBonus.defaultProps = {
  className: '',
};
